import * as Yup from 'yup';

import { createLocale } from 'locales';

const globalLocalize = createLocale('global');

export default Yup.object().shape({
  picture: Yup.string().required(globalLocalize('fieldRequiredErrorMessage')),
});
